import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

// Helpers de formulário
import { Modal, OverlayTrigger } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Overlay from '../Miscelania/Overlay';

import getLocale from '../../i18n/getLocale';

import LogbookSignatureModal from './LogbookSignatureModal';

class LogbookAppIntegrations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      flight_report_id: this.props.flight_report_id,
      email_logbook: '',
      password_logbook: '',
      showLogbookSignatureModal: false,
      archive_legs: [],
      update_legs: [],
      integrate_legs: [],
      modal_logbook_app: false,
      flight_report_leg_id: '',
      signature_modal_title: '',
      signature_modal_subtitle: '',
      signature_modal_confirmation: '',
      logbook_app_integration_type: null,
      flight_report_approval_id: this.props.flight_report_approval_id,
      modal_captain_login: this.props.modal_captain_login || false,
      integrationType: this.props.integrationType || false,
      renderButton: this.props.renderButton || false,
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleAlertWithArray = this.handleAlertWithArray.bind(this);

    this.actionsButtons = this.actionsButtons.bind(this);
    this.getLogbookLegs = this.getLogbookLegs.bind(this);
    this.getLogbookLegsIntegrationSubmit = this.getLogbookLegsIntegrationSubmit.bind(this);
    this.handleDataLegs = this.handleDataLegs.bind(this);
    this.logbookIntegration = this.logbookIntegration.bind(this);
    this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
    this.handleBulkAction = this.handleBulkAction.bind(this);
    this.sendAllLegs = this.sendAllLegs.bind(this);
    this.captainLogin = this.captainLogin.bind(this);
    this.approve = this.approve.bind(this);
    
    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleAlertWithArray(data, message, type, status, mode) {
    const errorMessages = Array.isArray(data) ? data : [];
    const messageElement = (
      <div>
        {message}
        {errorMessages.length > 0 && (
          <ul style={{ marginTop: 10, marginBottom: 0, paddingLeft: 20 }}>
            {errorMessages.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        )}
      </div>
    );

    if(mode === 'reset') {
      this.handleAlert('', '', '', 'reset');
    } else {
      this.handleAlert(messageElement, type, status);
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // Integração com o Logbook App

  // Ajuste de dados após integração
  handleDataLegs(responseJson) {
    const mainArray = responseJson.data.data.main;
    // Captura o último registro do array, que - muito provavelmente - é o novo trecho integrado
    // Não é garantido pois o retorno é ordem pela ordem dos horários dos voos
    // Mas ainda que não seja associado ao id correto, não há problema
    // Pois o objetivo é apenas atualizar para que o botão de integração mude
    const integratedRecord = mainArray[mainArray.length - 1];
    const archivedSigtrip = this.state.archive_legs.map(record => {
      if (record.flight_report_leg_id === this.state.flight_report_leg_id) {
        // Atualiza o logbook_external_id para o id do Logbook App
        return { ...record, logbook_external_id: integratedRecord.id };
      }
      return record;
    });
    const updatedSigtrip = this.state.update_legs.map(record => {
      if (record.flight_report_leg_id === this.state.flight_report_leg_id) {
        // Atualiza o logbook_external_id para o id do Logbook App
        return { ...record, logbook_external_id: integratedRecord.id };
      }
      return record;
    });
    const integratedSigtrip = this.state.integrate_legs.map(record => {
      if (record.flight_report_leg_id === this.state.flight_report_leg_id) {
        // Atualiza o logbook_external_id para o id do Logbook App
        return { ...record, logbook_external_id: integratedRecord.id };
      }
      return record;
    });
    this.setState({
      archive_legs: archivedSigtrip,
      update_legs: updatedSigtrip,
      integrate_legs: integratedSigtrip,
    });
  }

  // Botões de ação para integração com o Logbook App
  actionsButtons (cell, row) {
    var botao = (
      <div>
        {
          (row.logbook_external_id == null) ?
            <div className="btn-group">
              <button onClick={() => this.logbookIntegration(row.flight_report_leg_id, 'enviar')} className="btn btn-info btn-sm button-inline">
                <i className="fa fa-share"></i>
              </button>
            </div>
          :
            <div className="btn-group">
              <button onClick={() => this.logbookIntegration(row.flight_report_leg_id, 'reenviar')} className="btn btn-success btn-sm button-inline">
                <i className="fa fa-refresh"></i>
              </button>
              <button onClick={() => this.logbookIntegration(row.flight_report_leg_id, 'arquivar')} className="btn btn-danger btn-sm button-inline">
                <i className="fa fa-trash"></i>
              </button>
            </div>
        }
      </div>
    );

    return botao;
  }

  // Obter etapas de voo do Logbook App
  getLogbookLegs() {
    // Abrimos o modal para solicitar as credenciais do Logbook App
    this.setState({
      flight_report_leg_id: '',
      logbook_app_integration_type: 'obter'
    });
    this.handleLogbookSignatureSubmit({ email: '', password: '' });
  }

  // Após clicar para integrar com o Logbook App
  logbookIntegration(id, type) {
    if (type == 'reenviar') {
      if(!window.confirm('Esta etapa de voo já foi integrada. Deseja reenviar os dados para o Logbook App?')) {
        return;
      }
    }

    // Abrimos o modal para solicitar as credenciais do Logbook App
    this.setState({
      flight_report_leg_id: id,
      signature_modal_title: `Você tem certeza de que deseja integrar e ${type} os dados desta etapa de voo para o Logbook App?`,
      signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
      signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
      showLogbookSignatureModal: true,
      logbook_app_integration_type: type
    });
  }

  handleBulkAction(type) {
    let title = '';
    if (type === 'enviar-todos') {
      title = 'Você tem certeza de que deseja ENVIAR TODAS as etapas de voo para o Logbook App?';
    } else if (type === 'reenviar-todos') {
      title = 'Você tem certeza de que deseja REENVIAR TODAS as etapas de voo para o Logbook App?';
    } else if (type === 'arquivar-todos') {
      title = 'Você tem certeza de que deseja ARQUIVAR TODAS as etapas de voo no Logbook App?';
    }

    this.setState({
      flight_report_leg_id: null, // Ação em massa não tem id de trecho
      signature_modal_title: title,
      signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
      signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
      showLogbookSignatureModal: true,
      logbook_app_integration_type: type
    });
  }
  
  // Após preencher as credenciais do Logbook App
  handleLogbookSignatureSubmit(credentials) {
    // Recebe { email, password } do modal e atualiza o state
    this.setState({
      email_logbook: credentials.email,
      password_logbook: credentials.password,
      showLogbookSignatureModal: false
    }, () => {
      // Após informar as credenciais
      // Se for obtenção, chama a função para obter as etapas de voo
      if (this.state.logbook_app_integration_type == 'obter') {
        this.getLogbookLegsIntegrationSubmit();
      }
      // Se for envio, reenvio ou arquivamento de todos os trechos, chama a função de envio em massa
      if (
          this.state.logbook_app_integration_type === 'enviar-todos' ||
          this.state.logbook_app_integration_type === 'reenviar-todos' ||
          this.state.logbook_app_integration_type === 'arquivar-todos'
      ) {
        this.sendAllLegs(); // Pelo integrationType é que definimos se deve-se arquivar ou integrar as etapas
      }
    });
  }

  // Chamada para obter as etapas de voo do Logbook App
  getLogbookLegsIntegrationSubmit() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    const datasave = {
      flight_report_id: this.state.flight_report_id,
      email: this.state.email_logbook,
      password: this.state.password_logbook,
      action_type: this.state.integrationType
    };
    const header = this.refs.request_api.header('application/json');
    const self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/integrar/logbook/checar', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: JSON.stringify(datasave)
      })
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
      })
      .then((responseJson) => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            archive_legs: responseJson.data.archive,
            update_legs: responseJson.data.update,
            integrate_legs: responseJson.data.integrate,
            modal_logbook_app: true,
          });
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
        self.setState({
          email_logbook: '',
          password_logbook: '',
          logbook_app_integration_type: null,
        });
      })
      .catch((error) => {
        console.error(error);
      });
    });
  }

  // Chamada para integração de todos os trechos de voo com o Logbook App
  sendAllLegs() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    const datasave = {
      flight_report_id: this.state.flight_report_id,
      email: this.state.email_logbook,
      password: this.state.password_logbook,
      action_type: this.state.integrationType
    };
    const header = this.refs.request_api.header('application/json');
    const self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/integrar/logbook/executar', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: JSON.stringify(datasave)
      })
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
      })
      .then((responseJson) => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          if (self.state.integrationType == 'cancel') {
            self.setState({
              modal_logbook_app: false
            });
          }
          self.props.updateData(responseJson);
        } else {
          self.handleAlertWithArray(responseJson.data, responseJson.message, responseJson.status, 'open');
        }
        self.setState({
          email_logbook: '',
          password_logbook: '',
          logbook_app_integration_type: null,
        });
      })
      .catch((error) => {
        console.error(error);
      });
    });
  }

  captainLogin(event) {
    var self = this;
    event.preventDefault();
    if(window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
      self.handleAlert('', '', 'open');
      var datasave = {
        username: this.state.username,
        password: this.state.password,
        flight_report_approval_id: this.state.flight_report_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/sub_commander_approval/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              modal_logbook_app: false
            });
            self.props.updateData(responseJson);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approve(event) {
    var self = this;
    event.preventDefault();
    if(window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
      self.handleAlert('', '', 'open');
      var datasave = {
        flight_report_approval_id: this.state.flight_report_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/commander_approval/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              modal_logbook_app: false
            });
            self.props.updateData(responseJson);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
  
    return (
      <div className="pull-left" style={{ display: 'inline-block' }}>
        <RequestApi ref={'request_api'} />
        {!this.state.modal_logbook_app && <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />}
        
        {this.props.renderButton == true &&
          <button onClick={this.getLogbookLegs} className={this.props.buttonClass}>
            <OverlayTrigger trigger="hover" placement="top" overlay={this.props.popover("Logbook App", null, "Integrar etapas de voo", "", "Visualize os detalhes das etapas de voo e envie para o Logbook App.")}>
              <i className="fa fa-check"> {this.props.buttonTitle}</i>
            </OverlayTrigger>
          </button>
        }

        {/* Modal de assinatura do LogbookApp */}
        <LogbookSignatureModal
          show={this.state.showLogbookSignatureModal}
          onHide={() => this.setState({ showLogbookSignatureModal: false })}
          onSubmit={this.handleLogbookSignatureSubmit}
          title={this.state.signature_modal_title}
          subtitle={this.state.signature_modal_subtitle}
          confirmation={this.state.signature_modal_confirmation}
        />

        {/* Modal de etapas de voo para serem sincronizadas com o LogbookApp */}
        <Modal show={this.state.modal_logbook_app} onHide={() => this.setState({modal_logbook_app: false})} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header closeButton>
            <h4 className="pull-left"><strong>Integrar com o Logbook App</strong></h4>
          </Modal.Header>
          <Modal.Body>
            {this.state.modal_logbook_app && <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />}
            {this.state.integrate_legs.length > 0 &&
              <div>
                <h4>Etapas/Trechos a serem cadastrados</h4>
                <hr/>
                <BootstrapTable data={this.state.integrate_legs} pagination={false} striped={true} hover={true} options={{noDataText: this.locale.general.semDados}}>
                  <TableHeaderColumn dataField={'flight_report_leg_id'} isKey={true} hidden={true}>ID</TableHeaderColumn>
                  <TableHeaderColumn dataField={'leg_number'} dataAlign="center" width='100'>N°</TableHeaderColumn>
                  <TableHeaderColumn dataField={'date'} dataAlign="center" width='100'>Data</TableHeaderColumn>
                  <TableHeaderColumn dataField={'departure_location_str'} dataAlign="center" width='160'>Origem</TableHeaderColumn>
                  <TableHeaderColumn dataField={'arrival_location_str'} dataAlign="center" width='160'>Destino</TableHeaderColumn>
                  <TableHeaderColumn dataField={'engines_start_time'} dataAlign="center" width='160'>Partida</TableHeaderColumn>
                  <TableHeaderColumn dataField={'departure_time'} dataAlign="center" width='160'>Decolagem</TableHeaderColumn>
                  <TableHeaderColumn dataField={'landing_time'} dataAlign="center" width='160'>Pouso</TableHeaderColumn>
                  <TableHeaderColumn dataField={'engines_shut_off_time'} dataAlign="center" width='160'>Corte</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_day'} dataAlign="center" width='160'>Diurno</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_night'} dataAlign="center" width='160'>Noturno</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_ifr'} dataAlign="center" width='160'>IFR</TableHeaderColumn>
                  <TableHeaderColumn dataField={'fuel_total'} dataAlign="center" width='160'>Total de combustível</TableHeaderColumn>
                  <TableHeaderColumn dataField={'people_on_flight'} dataAlign="center" width='160'>PAX</TableHeaderColumn>
                  <TableHeaderColumn dataField={'cargo_str'} dataAlign="center" width='160'>Carga</TableHeaderColumn>
                  <TableHeaderColumn dataField={'cycles'} dataAlign="center" width='160'>Ciclos</TableHeaderColumn>
                  <TableHeaderColumn dataField={'landings'} dataAlign="center" width='160'>Pousos</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_type_str'} dataAlign="center" width='160'>Natureza do Voo</TableHeaderColumn>
                </BootstrapTable>
                <hr/>
              </div>
            }
            {this.state.update_legs.length > 0 &&
              <div>
                <h4>Etapas/Trechos a serem atualizados</h4>
                <hr/>
                <BootstrapTable data={this.state.update_legs} pagination={false} striped={true} hover={true} options={{noDataText: this.locale.general.semDados}}>
                  <TableHeaderColumn dataField={'flight_report_leg_id'} isKey={true} hidden={true}>ID</TableHeaderColumn>
                  <TableHeaderColumn dataField={'leg_number'} dataAlign="center" width='100'>N°</TableHeaderColumn>
                  <TableHeaderColumn dataField={'date'} dataAlign="center" width='100'>Data</TableHeaderColumn>
                  <TableHeaderColumn dataField={'departure_location_str'} dataAlign="center" width='160'>Origem</TableHeaderColumn>
                  <TableHeaderColumn dataField={'arrival_location_str'} dataAlign="center" width='160'>Destino</TableHeaderColumn>
                  <TableHeaderColumn dataField={'engines_start_time'} dataAlign="center" width='160'>Partida</TableHeaderColumn>
                  <TableHeaderColumn dataField={'departure_time'} dataAlign="center" width='160'>Decolagem</TableHeaderColumn>
                  <TableHeaderColumn dataField={'landing_time'} dataAlign="center" width='160'>Pouso</TableHeaderColumn>
                  <TableHeaderColumn dataField={'engines_shut_off_time'} dataAlign="center" width='160'>Corte</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_day'} dataAlign="center" width='160'>Diurno</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_night'} dataAlign="center" width='160'>Noturno</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_ifr'} dataAlign="center" width='160'>IFR</TableHeaderColumn>
                  <TableHeaderColumn dataField={'fuel_total'} dataAlign="center" width='160'>Total de combustível</TableHeaderColumn>
                  <TableHeaderColumn dataField={'people_on_flight'} dataAlign="center" width='160'>PAX</TableHeaderColumn>
                  <TableHeaderColumn dataField={'cargo_str'} dataAlign="center" width='160'>Carga</TableHeaderColumn>
                  <TableHeaderColumn dataField={'cycles'} dataAlign="center" width='160'>Ciclos</TableHeaderColumn>
                  <TableHeaderColumn dataField={'landings'} dataAlign="center" width='160'>Pousos</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_type_str'} dataAlign="center" width='160'>Natureza do Voo</TableHeaderColumn>
                </BootstrapTable>
                <hr/>
              </div>
            }
            {this.state.archive_legs.length > 0 &&
              <div>
                <h4>Etapas/Trechos a serem arquivados</h4>
                <hr/>
                <BootstrapTable data={this.state.archive_legs} pagination={false} striped={true} hover={true} options={{noDataText: this.locale.general.semDados}}>
                  <TableHeaderColumn dataField={'flight_report_leg_id'} isKey={true} hidden={true}>ID</TableHeaderColumn>
                  <TableHeaderColumn dataField={'leg_number'} dataAlign="center" width='100'>N°</TableHeaderColumn>
                  <TableHeaderColumn dataField={'date'} dataAlign="center" width='100'>Data</TableHeaderColumn>
                  <TableHeaderColumn dataField={'departure_location_str'} dataAlign="center" width='160'>Origem</TableHeaderColumn>
                  <TableHeaderColumn dataField={'arrival_location_str'} dataAlign="center" width='160'>Destino</TableHeaderColumn>
                  <TableHeaderColumn dataField={'engines_start_time'} dataAlign="center" width='160'>Partida</TableHeaderColumn>
                  <TableHeaderColumn dataField={'departure_time'} dataAlign="center" width='160'>Decolagem</TableHeaderColumn>
                  <TableHeaderColumn dataField={'landing_time'} dataAlign="center" width='160'>Pouso</TableHeaderColumn>
                  <TableHeaderColumn dataField={'engines_shut_off_time'} dataAlign="center" width='160'>Corte</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_day'} dataAlign="center" width='160'>Diurno</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_night'} dataAlign="center" width='160'>Noturno</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_time_ifr'} dataAlign="center" width='160'>IFR</TableHeaderColumn>
                  <TableHeaderColumn dataField={'fuel_total'} dataAlign="center" width='160'>Total de combustível</TableHeaderColumn>
                  <TableHeaderColumn dataField={'people_on_flight'} dataAlign="center" width='160'>PAX</TableHeaderColumn>
                  <TableHeaderColumn dataField={'cargo_str'} dataAlign="center" width='160'>Carga</TableHeaderColumn>
                  <TableHeaderColumn dataField={'cycles'} dataAlign="center" width='160'>Ciclos</TableHeaderColumn>
                  <TableHeaderColumn dataField={'landings'} dataAlign="center" width='160'>Pousos</TableHeaderColumn>
                  <TableHeaderColumn dataField={'flight_type_str'} dataAlign="center" width='160'>Natureza do Voo</TableHeaderColumn>
                </BootstrapTable>
                <hr/>
              </div>
            }
            <div style={{marginBottom: '20px'}}>
              {this.state.integrationType == 'approve' &&
                <button onClick={() => this.handleBulkAction('enviar-todos')} className="btn btn-info btn-block">
                  <i className="fa fa-share"></i> Integrar todas as etapas do relatório
                </button>
              }
              {this.state.integrationType == 'cancel' &&
                <div>
                  <button onClick={() => this.handleBulkAction('arquivar-todos')} className="btn btn-danger btn-block">
                    <i className="fa fa-trash"></i> Arquivar todas as etapas do relatório
                  </button>
                </div>
              }
            </div>
            {this.state.modal_captain_login && 
              <div>
                <hr/>
                <h4>Aprovação do Relatório</h4>
                <p>Clique no botão abaixo para prosseguir com a aprovação do relatório.</p>
                <form onSubmit={this.approve}>
                  <button className="btn btn-success btn-block" type="submit"><i className="fa fa-check"></i> Aprovar</button>
                </form>
              </div>
            }
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm" onClick={() => this.setState({modal_logbook_app: false})}>
              <i className="fa fa-fw fa-close"></i> Fechar
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default LogbookAppIntegrations;



// WEBPACK FOOTER //
// ./src/Components/LogbookAppIntegration/LogbookAppIntegrations.js